import images from "../../../utilities/images/images";

const hasHomeworkItem = (items = []) =>
  items.some((item) =>
    String(item?.name || "").toLowerCase().includes("homework")
  );

export const enrichEnhanceYourPractice = (section, targetId) => {
  const isHomeworkVisible = Number(targetId) !== 5;
  if (!section || !isHomeworkVisible) return section;

  const data = Array.isArray(section.data) ? section.data : [];
  if (hasHomeworkItem(data)) return section;

  return {
    ...section,
    data: [
      ...data,
      {
        id: "homework",
        name: "Homework",
        icon: images.pendingIcon,
      },
    ],
  };
};

export const buildQuickActionItems = (practiceList, targetId) => {
  const main = practiceList?.main_practice_dashboard?.data ?? [];
  const enhance =
    enrichEnhanceYourPractice(practiceList?.enhance_your_practice, targetId)
      ?.data ?? [];

  const mapItem = (item, section, index) => ({
    // Always include index — many series cards share the same API id.
    id: `${section}-${item?.id ?? "item"}-${index}`,
    name: item?.name || item?.sublistName || "",
    icon: item?.icon || item?.pimage,
    subtitle: item?.description || "",
    section,
    raw: item,
  });

  return [
    ...main.map((item, index) => mapItem(item, "main_practice_dashboard", index)),
    ...enhance.map((item, index) => mapItem(item, "enhance_your_practice", index)),
  ].filter((item) => item.name);
};
